import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import { Outlet, useLocation } from "react-router-dom";
import MerchantDrawer from './MerchantDrawer';
import MerchantAppBar from './MerchantAppBar';
import { Container } from '@mui/material';
import { useSocket } from 'src/_contexts/socket';
import { getCurrentUserProfile } from "src/_store/entities/profile";
import { useDispatch, useSelector } from 'react-redux';
import CompleteProfileInfoAlert from 'src/_modules/Account/components/CompleteProfileInfoAlert';
import { AcceptTermsAndConditionsAlert, PlanExpirationAlert } from 'src/_modules/Account/components';
import { containerSpacing } from 'src/_utils/containerSpacing';
import WarehousesManualAlert from 'src/_modules/Account/components/WarehousesManualAlert';
import { Alerts, GlobalConfirmDialog } from 'src/_modules/common';
import CreditsBalanceNotEnoughDialog from 'src/_modules/common/Dialogs/CreditsBalanceNotEnoughDialog';
import { HelpCenter } from 'src/components/common';

import { startTour } from 'src/_store/entities/tutorial';
import { TOUR_IDS } from 'src/_modules/MapitTutorial/tours';
import MapitTutorial from 'src/_modules/MapitTutorial';
import ShipmentCreationFailedAlert from 'src/_modules/Account/components/ShipmentCreationFailedAlert';

export default function ClippedDrawer() {
    const dispatch = useDispatch();

    const profile = useSelector((state) => state.entities.profile.profile);
    // const { credits } = useSelector((state) => state.entities.creditsAndSubscription)

    const [openDrawer, setOpenDrawer] = useState(false)
    const toggleDrawerHandler = () => {
        setOpenDrawer((prevState) => !prevState)
    }

    const { socket } = useSocket();

    const refetchProfileAccount = (data) => {
        if (["ACCOUNT_ACTIVATED"].includes(data.type)) {
            dispatch(getCurrentUserProfile())
        }
    }

    useEffect(_ => {
        if (socket) {
            socket.on("notification", refetchProfileAccount);
        }
        return _ => socket && socket.off('notification', refetchProfileAccount);
    }, [socket])

    const location = useLocation()
    const spacing = containerSpacing(location.pathname)

    const deliveryMethod = profile?.merchant?.deliveryMethod || [];
    const isFirstTourCompleted = localStorage.getItem("isFirstTourCompleted") === "true";

    // const idDocumentNotCompleted = !profile?.merchant?.idDocument?.name
    // const walletNotChargedBefore = credits <= 0 && profile?.merchant?.currentStatus === "WAITING"

    useEffect(() => {
        if (deliveryMethod?.includes("MAPIT_SHIP") && !isFirstTourCompleted /* && idDocumentNotCompleted && walletNotChargedBefore */) {
            dispatch(startTour(TOUR_IDS.FIRST_TOUR));
        }
    }, [deliveryMethod, isFirstTourCompleted /*, idDocumentNotCompleted, walletNotChargedBefore */]);
    return (
        <Box sx={{ display: { xs: "block", lg: "flex" } }}>
            <MapitTutorial />
            <CssBaseline />
            <MerchantAppBar toggleDrawer={toggleDrawerHandler} />
            {/* minWidth: 0 (here and on <main>) lets the content shrink to the space beside the drawer; without it wide
                tables/tab rows push the page past the viewport, where html's overflow-x: hidden makes it unreachable */}
            <Box sx={{ display: { xs: "block", lg: "flex" }, flexGrow: 1, minWidth: 0 }}>
                <MerchantDrawer openDrawer={openDrawer} toggleDrawer={toggleDrawerHandler} />
                <Box component="main" sx={{ flexGrow: 1, minWidth: 0, py: spacing ? 3 : undefined }}>
                    <Toolbar />
                    <CompleteProfileInfoAlert />
                    <AcceptTermsAndConditionsAlert />
                    <WarehousesManualAlert />
                    <GlobalConfirmDialog />
                    <PlanExpirationAlert />
                    <CreditsBalanceNotEnoughDialog />
                    <ShipmentCreationFailedAlert/>
                    <Alerts />
                    <HelpCenter />
                    <Container
                        maxWidth={false}
                        style={{
                            paddingLeft: spacing ? undefined : 0,
                            paddingRight: spacing ? undefined : 0
                        }}
                    >
                        <Outlet />
                    </Container>
                </Box>
            </Box>
        </Box>
    )
}
